import { LatLng } from '../components/LocationMap';

/** Prague city center — fallback when geolocation is unavailable. */
export const PRAGUE_CENTER: LatLng = { lat: 50.0755, lng: 14.4378 };

export const DEFAULT_SEARCH_RADIUS_KM = 20;

export const SEARCH_RADIUS_OPTIONS_KM = [5, 10, 20, 50, 100] as const;

export type SearchLocationSource = 'device' | 'prague' | 'custom';

export interface ResolvedSearchCenter {
  center: LatLng;
  fromDevice: boolean;
}

/** Uses device location only when permission was already granted (no browser prompt). */
export function resolveDeviceSearchCenterIfGranted(): Promise<ResolvedSearchCenter | null> {
  if (!navigator.geolocation) return Promise.resolve(null);

  return navigator.permissions
    .query({ name: 'geolocation' })
    .then(permission => {
      if (permission.state !== 'granted') return null;

      return new Promise<ResolvedSearchCenter | null>(resolve => {
        navigator.geolocation.getCurrentPosition(
          pos =>
            resolve({
              center: { lat: pos.coords.latitude, lng: pos.coords.longitude },
              fromDevice: true,
            }),
          () => resolve(null),
          { enableHighAccuracy: false, timeout: 8000, maximumAge: 300_000 }
        );
      });
    })
    .catch(() => null);
}
